import { makeStyles } from '@material-ui/core/styles';
import { userTheme } from 'consts/config';

export default makeStyles(theme => ({
  ReturnSubscriptionTreeView: {
    '&__card': {
      borderRadius: '12px',
      marginTop: 10,
      '&__children': {
        backgroundColor: theme.palette.existingOrganizations.cardColor,
        borderLeft: `1px solid ${theme.palette.existingOrganizations.linkColor}`,
        borderRight: `1px solid ${theme.palette.existingOrganizations.linkColor}`,
        padding: 20,
        '&__grand-children': {
          backgroundColor: theme.palette.existingOrganizations.cardColor,
          border: `1px solid ${theme.palette.existingOrganizations.linkColor}`,
          '&:hover': {
            backgroundColor: theme.palette.existingOrganizations.hoverCardColor,
            border: `1px solid ${theme.palette.existingOrganizations.linkColor}`,
            opacity: 0.9,
          },
        },
        '&:hover': {
          backgroundColor: theme.palette.existingOrganizations.hoverCardColor,
          opacity: 0.9,
        },
      },
      '&__no-bottom-radius': {
        borderBottomLeftRadius: '0px !important',
        borderBottomRightRadius: '0px !important',
      },
      '&--box-shadow': {
        boxShadow:
          theme.palette.type === userTheme.dark
            ? `0 6px 10px -4px ${theme.palette.black}`
            : `0 6px 10px -4px ${theme.palette.iconDivider}`,
      },
    },
    '&__main-border': {
      borderLeft: `1px solid ${theme.palette.existingOrganizations.linkColor}`,
      borderRight: `1px solid ${theme.palette.existingOrganizations.linkColor}`,
      borderTop: `1px solid ${theme.palette.existingOrganizations.linkColor}`,
      borderTopLeftRadius: '12px',
      borderTopRightRadius: '12px',
    },
    '&__no-expansion': {
      backgroundColor: theme.palette.existingOrganizations.linkColor,
      height: '1px',
      width: '100%',
    },
    '&__organization': {
      height: '100%',
      borderLeft: `3px solid ${theme.palette.primary.main}`,
      marginLeft: '35px',
      zIndex: 5,
      '&__border': {
        '&__bottom-left': {
          borderBottom: `3px solid ${theme.palette.primary.main}`,
          borderLeft: `3px solid ${theme.palette.primary.main}`,
          borderBottomLeftRadius: '20px',
          height: '50%',
        },
        '&__end': {
          borderBottom: `3px solid ${theme.palette.primary.main}`,
          borderLeft: `3px solid ${theme.palette.primary.main}`,
          height: '50%',
          marginLeft: '35px',
          borderBottomLeftRadius: '20px',
        },
      },
      '&--border-left': {
        borderLeft: `3px solid ${theme.palette.primary.main}`,
      },
      '&--margin-left': {
        marginLeft: '-3px',
      },
      '&--padding-left': {
        paddingLeft: '35px',
      },
    },
    '&__title': {
      '&--font-size': {
        fontSize: 14,
      },
    },
    '&__wrapper': {
      height: '100%',
      width: '100%',
      '&__button': {
        height: '60%',
        width: '100%',
        '&--align-item': {
          '&--center': {
            alignItems: 'center',
          },
          '&--flex-end': {
            alignItems: 'flex-end',
          },
        },
        '&--color': {
          color: theme.palette.fontColor,
        },
        '&--display': {
          display: 'flex',
        },
        '&--margin-top': {
          marginTop: '-2px',
        },
      },
    },
  },
}));
